/// <amd-module name="Search/Code/Services/PathService" />
import { Services, VssService } from "VSS/Platform/Context";
import { IVersionControlPathService } from "Search/Shared/Base/Types";
import { getFileContentUrl, RepositoryType} from "VC/Markdown/Plugins/PathUtilities/VersionControlUrlUtilities";

class VersionControlPathService extends VssService implements IVersionControlPathService {
    public getGitItemContentUrl(project: string, repositoryId: string, path: string): string {
        return getFileContentUrl(this.pageContext, repositoryId, RepositoryType.Git, project, path)
    }

    public getTfvcItemContentUrl(project: string, path: string): string {
        return getFileContentUrl(this.pageContext, `$/${project}`, RepositoryType.Tfvc, project, path);
    }

    public getCustomItemContentUrl(project: string, repository: string, path: string, fileName: string, contentId: string): string {        
        // ToDo: handle custom item url generation.
        return "";
    }
}

Services.add("IVersionControlPathService", { serviceFactory: VersionControlPathService });
